import React, { Component } from 'react'
import API_URL from '../../../../common/url';
import $ from "../../../../common/AjaxRequest";
import { Button, Icon, Tooltip, message, Input, Table } from 'antd';
import '../index.less';

const { TextArea } = Input;

export default class Intro extends Component {
    state = {
        params: {},
        type: 'view',
        data: [],
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { clinicalQuotationRecordId } = this.props;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.getCompanySynopsis,
            data: { clinicalQuotationRecordId },
            dataType: 'json',
            doneResult: res => {
                const { companyPersonnelDistributions, quotationCompanySynopsis } = res;
                const { companySynopsis, team, quotationCompanySynopsisId } = quotationCompanySynopsis;
                this.setState({
                    data: companyPersonnelDistributions,
                    params: {
                        companySynopsis,
                        team,
                        quotationCompanySynopsisId,
                    },
                })
            }
        };
        $.sendRequest(options);
    }

    handleChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params: { ...params } });
    }

    submit = () => {
        const { params } = this.state;
        const { clinicalQuotationRecordId } = this.props;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.updateCompanySynopsis,
            data: { 
                ...params,
                clinicalQuotationRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    type: 'view',
                },() => this.loadData())
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const columns = [        
            {
                title: '直辖市/省份/自治区',
                dataIndex: 'provinceName',
                key: 'provinceName',
                width: 100,
            }, 
            {
                title: <div style={{ textAlign: 'center' }}>城市</div>,
                dataIndex: 'cityName',
                key: 'cityName',
                width: 500,
            }
        ]
        return columns
    }

    setStyle = (data) => {
        let arr = (data || "").split("\n");
        return <div style={{ paddingRight: 15}}>
                {arr.map((el) => (
                    <span>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {el}
                        <br />
                    </span>
                ))}
            </div>
    }

    render() {
        const { params, type, data } = this.state;
        const { companySynopsis, team } = params;
        const { recordData } = this.props;
        const { bdBaAuth, evaluateStatus } = recordData;
        return (
            <div>
                <div style={{ fontSize: 20, fontWeight: 600, textAlign: 'center', margin: '20px 0' }}>
                    公司背景信息
                </div>
                <div className='intro_content'>
                    <div className='content_item'>
                        <div className='item_left' style={{ fontSize: 15, fontWeight: 900 }}>津石医药简介</div>
                        <div className='item_right'>
                            {
                                type === 'view' ? this.setStyle(companySynopsis) :
                                    <TextArea
                                        rows={5}
                                        value={companySynopsis}
                                        onChange={e => this.handleChange(e, 'companySynopsis')}
                                    />
                            }
                        </div>
                    </div>
                    <div className='content_item'>
                        <div className='item_left' style={{ fontSize: 15, fontWeight: 900 }}>团队</div>
                        <div className='item_right'>
                            {
                                type === 'view' ? this.setStyle(team) :
                                    <TextArea
                                        rows={4}
                                        value={team}
                                        onChange={e => this.handleChange(e, 'team')}
                                    />
                            }
                        </div>
                    </div>
                    <div>
                        <div style={{ fontSize: 15, fontWeight: 900, marginBottom: 15 }}>人员分布</div>
                        <Table 
                            bordered
                            pagination={false}
                            rowKey={record => record.quotationVisitCompanyPersonnelDistributionId}
                            dataSource={data}
                            columns={this.getColumns()}
                        />
                    </div>
                </div>
                { 
                    (bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') && <div className='Forecast_Params_footer'>
                        {
                            type === 'view' ?
                                <Button
                                    type="primary"
                                    onClick={() => this.setState({
                                        type: 'edit',
                                    })}
                                >编辑</Button> :
                                <div>
                                    <Button
                                        style={{ marginRight: 20 }}
                                        onClick={() => this.setState({
                                            type: 'view',
                                        }, () => this.loadData(params.evaluateRecordId))}
                                    >取消</Button>
                                    <Button
                                        type="primary"
                                        onClick={this.submit}
                                    >确定</Button>
                                </div>
                        }
                    </div>
                }
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/Intro.js